// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__cxDvD","header":"Login_header__DCIxP","logo":"Login_logo__3R5vb","content":"Login_content__21R4P"};